import { render, staticRenderFns } from "./askdetails.vue?vue&type=template&id=4bd09532&scoped=true&"
import script from "./askdetails.vue?vue&type=script&lang=js&"
export * from "./askdetails.vue?vue&type=script&lang=js&"
import style0 from "./askdetails.vue?vue&type=style&index=0&id=4bd09532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd09532",
  null
  
)

export default component.exports